import { render, staticRenderFns } from "./feature-card.vue?vue&type=template&id=c111d4b4&scoped=true&"
import script from "./feature-card.vue?vue&type=script&lang=ts&"
export * from "./feature-card.vue?vue&type=script&lang=ts&"
import style0 from "./feature-card.vue?vue&type=style&index=0&id=c111d4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c111d4b4",
  null
  
)

export default component.exports